module.exports = __webpack_public_path__ + "static/media/file-code.16f462d4.svg";